import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { APP_SELECTOR } from './app/app.config-constants';

(async () => {
  const app = await createApplication(appConfig);

  const element = createCustomElement(AppComponent, {
    injector: app.injector,
  });

  customElements.define(APP_SELECTOR, element);
})();
